const TOTALS_VIEWER_UIDS = new Set([
  'BLRmDmoVePRylWJ15hEp2ziCEUj1',
  'HpMiFyBZnwX6EUf6VR9iCsHkqo82',
]);

export function canViewOrderAccountingTotals(user) {
  return TOTALS_VIEWER_UIDS.has(user?.uid);
}
